import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '../../context/AuthContext';
import { BookingProvider } from '../../context/BookingContext';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import Home from '../Pages/Home';
import Booking from '../BookingSystem/Booking';
import UserDashboard from '../Dashboard/UserDashboard';
import PractitionerDashboard from '../Dashboard/PractitionerDashboard';
import PrivateRoute from '../Auth/PrivateRoute';
import SuperAdminDashboard from '../Dashboard/SuperAdminDashboard';
import AuthModal from '../Auth/AuthModal';
// Importer les nouvelles pages légales
import TermsOfService from '../Pages/TermsOfService';
import PrivacyPolicy from '../Pages/PrivacyPolicy';

import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />

              {/* Routes protégées */}
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <UserDashboard />
                  </PrivateRoute>
                }
              />

              <Route
                path="/practitioner"
                element={
                  <PrivateRoute role="practitioner">
                    <PractitionerDashboard />
                  </PrivateRoute>
                }
              />

              <Route
                path="/admin"
                element={
                  <PrivateRoute role="admin">
                    <SuperAdminDashboard />
                  </PrivateRoute>
                }
              />

              {/* Système de réservation */}
              <Route
                path="/booking"
                element={
                  <BookingProvider>
                    <Booking />
                  </BookingProvider>
                }
              />

              {/* Route avec ID du praticien en paramètre */}
              <Route
                path="/booking/:practitionerId/:serviceId"
                element={
                  <BookingProvider>
                    <Booking />
                  </BookingProvider>
                }
              />

              {/* Pages légales */}
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            </Routes>
          </main>
          <Footer />
          <AuthModal />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;